import React from 'react';
import './UnderConstruction.scss';
import images from '../../assets/images';
import { visibility } from '../../redux/slices/rightSideAd';
import { useAppDispatch,useAppSelector } from '../../redux/app/hooks';

const UnderConstruction = () => {
  const {underContstructionImage} = images;
  const role = useAppSelector((state) => state.auth.role);
  const dispatch = useAppDispatch();
  dispatch(visibility({isVisible: false}));
  // dispatch(isSelected({selected: ""}));
  return (
    <div className={`${role ? "underConstructionImageContainer" :"" }`}><img src={underContstructionImage} alt="UnderContruction" className={`${role ? "underConstructionInsideDashboard" : "underConstruction"}`} /></div>
  )
}

export default UnderConstruction
